import { UsersLoader } from "./UsersLoader";

export enum GrantType {
  password = "password",
  token = "refresh_token",
}

export interface PasswordTokenRequest {
  grant_type: GrantType.password;
  client_id: string;
  client_secret: string;
  scope?: string;
  username: string;
  password: string;
}

export interface RefreshTokenRequest {
  grant_type: GrantType.token;
  client_id: string;
  client_secret: string;
  scope?: string;
  refresh_token: string;
}

export interface OauthTokenResponse {
  token_type: string;
  expires_in: number;
  access_token: string;
  refresh_token: string;
}

export interface OauthTokenErrorResponse {
  error: string;
  error_description: string;
  hint: string;
  message: string;
}

export class AuthApi {
  public static login(data: PasswordTokenRequest) {
    return UsersLoader.post<OauthTokenResponse>({ url: "/oauth/token", data });
  }

  public static token(data: RefreshTokenRequest) {
    return UsersLoader.post<OauthTokenResponse>({ url: "/oauth/token", data });
  }
}
